import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule, NgForm} from "@angular/forms";
import {CoreService} from "../../../../common/core.service";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";
import ILanguageViewData = NCVIB.app.Main.Administration.Translation.ILanguageViewData;
import ITranslationViewData = NCVIB.app.Main.Administration.Translation.ITranslationViewData;
import ISaveTranslationCommand = NCVIB.app.Main.Administration.Translation.EditTranslation.ISaveTranslationCommand;
import {SaveAndCancelButtonsComponent} from "../../../../common/buttons/save-and-cancel-buttons/save-and-cancel-buttons.component";
import {ModalHeaderComponent} from "../../../../common/modal-header/modal-header.component";
import IAutoTranslationCommand = NCVIB.app.Main.Administration.Translation.AutoTranslation.IAutoTranslationCommand;
import IAutoTranslationResult = NCVIB.app.Main.Administration.Translation.AutoTranslation.IAutoTranslationResult;
import ICultureTranslationViewData = NCVIB.app.Main.Administration.Translation.ICultureTranslationViewData;
import ILoadAllCultureTranslationsCommand = NCVIB.app.Main.Administration.Translation.ILoadAllCultureTranslationsCommand;

@Component({
    selector: 'edit-translation',
    templateUrl: './edit-translation.component.html',
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule,
        SaveAndCancelButtonsComponent,
        ModalHeaderComponent
    ],
    styleUrls: ['./edit-translation.component.css']
})
export class EditTranslationComponent implements OnInit {

    constructor(
        public activeModal: NgbActiveModal,
        private core: CoreService) {
    }

    public referenceLanguage: ILanguageViewData | undefined;
    public translationLanguage: ILanguageViewData | undefined;
    public unchangedTranslation: ITranslationViewData | undefined;
    public translation: ITranslationViewData | undefined;

    ngOnInit(): void {
    }

    public setLanguages(referenceLanguage: ILanguageViewData, translationLanguage: ILanguageViewData) {
        this.referenceLanguage = referenceLanguage;
        this.translationLanguage = translationLanguage;
    }

    public setTranslation(translation: ITranslationViewData) {
        this.unchangedTranslation = {...translation};
        this.translation = {...translation};

        this.loadTranslations(translation);
    }

    public canSave(form: NgForm): boolean {
        return !!form.valid;
    }

    public save(form: NgForm): void {
        if (this.canSave(form)) {
            const command: ISaveTranslationCommand = {
                referenceId: this.translation!.referenceId,
                referenceText: this.translation!.referenceText ?? "",
                id: this.translation!.id,
                newTranslation: this.translation!.translationText ?? ""
            };

            this.core.post<void>(`api/v2/administration/translation/save-translation`,
                command,
                "Save Translation",
                true)
                .subscribe(x => {
                    this.activeModal.close(command);
                });
        }
    }

    public cancel(): void {
        this.activeModal.dismiss('cancel');
    }

    private autoTranslation(command: IAutoTranslationCommand): Promise<string> {
        return new Promise(resolve => {
            this.core.post<IAutoTranslationResult>(`api/v2/administration/translation/auto-translation`,
                command,
                "Auto Translation",
                true)
                .subscribe((result: IAutoTranslationResult) => {
                    console.log(result);
                    resolve(result.suggestion);
                });
        });
    }

    public suggestReferenceText() {
        if (!this.translation?.key) {
            alert("key missing")
            return;
        }

        let text = this.toPlainText(this.translation.key);

        let command: IAutoTranslationCommand = {
            text: text,
            referenceLanguage: undefined,
            translationLanguage: this.referenceLanguage!.languageCode
        }

        this.autoTranslation(command).then(result => {
            this.translation!.referenceText = result;
        });
    }

    public suggestTranslationText() {
        let text = this.translation?.referenceText?.replace("MT - ", "") ?? "";

        let command: IAutoTranslationCommand = {
            text: text,
            referenceLanguage: this.referenceLanguage!.languageCode,
            translationLanguage: this.translationLanguage!.languageCode
        }

        this.autoTranslation(command).then(result => {
            this.translation!.translationText = result;
        });
    }

    private toPlainText(input: string): string {
        if (input.startsWith("_")) {
            input = input.slice(1);
        }

        let result = input.replace(/_/g, " ");
        result = result.replace(/([a-z])([A-Z])/g, "$1 $2");

        return result.charAt(0) + result.slice(1).toLowerCase();
    }

    public translations: ICultureTranslationViewData[] = [];

    private loadTranslations(translation: NCVIB.app.Main.Administration.Translation.ITranslationViewData) {
        let command: ILoadAllCultureTranslationsCommand = {
            key: translation.key
        }

        this.core.post<ICultureTranslationViewData[]>(`api/v2/administration/load-all-culture-translations`, command, "Load all culture translations", false)
            .subscribe(result => {
                this.translations = result;
            });
    }

    referenceTextChanged() {
        if (this.referenceLanguageAndTranslationLanguageAreTheSame()) {
            this.translation!.translationText = this.translation!.referenceText;
        }
    }

    private referenceLanguageAndTranslationLanguageAreTheSame() {
        return this.referenceLanguage?.languageCode == this.translationLanguage?.languageCode;
    }

    translationTextChanged() {
        if (this.referenceLanguageAndTranslationLanguageAreTheSame()) {
            this.translation!.referenceText = this.translation!.translationText;
        }
    }
}
